import { FC } from 'react';
import classes from '../../asset/css/subscription-detail/summary.module.css';
import NumberFormat from 'react-number-format';
import {SummaryType} from "../../types/summary-type";
import dayjs from "dayjs";

export const Summary: FC<{ summary?: SummaryType }> = ({ summary }) => {
  return (
    <>
      <div className={classes.mypage_subsc_summary}>
        <div>
          <div>変更締切日</div>
          <div>{summary ? dayjs(summary.nextBillingDate).add(-1, 'day').format('YYYY年 M月DD日') : ''}</div>
        </div>
        <div>
          <div>次回お届け予定日</div>
          <div>{summary ? dayjs(summary.deliveryDate).format('YYYY年 M月DD日') : ''}</div>
        </div>
        <div>
          <div>合計金額</div>
          <div>
            <NumberFormat
              displayType="text"
              value={summary ? summary.totalPrice : 0}
              thousandSeparator={true}
              prefix="￥"
            />
          </div>
        </div>
      </div>
    </>
  );
};
